module.exports = __webpack_public_path__ + "static/media/logSpeedActive.63a89974.svg";